import {DurationUnit, ProofRequirement, WorkingTimeTypeRecordingMode} from "@/shared/timrTypes";

export function getProofRequirementOptions(recordingMode: WorkingTimeTypeRecordingMode, editUnit: DurationUnit): ProofRequirement[] {
	if (recordingMode === WorkingTimeTypeRecordingMode.ALLOWED || recordingMode === WorkingTimeTypeRecordingMode.NOT_ALLOWED) {
		return [ProofRequirement.NOT_APPLICABLE];
	}
	// BY_REQUEST - no REQUIRED_AFTER_DAYS for minute-based working time types, as it is not applicable for them
	const baseOptions = [ProofRequirement.NOT_APPLICABLE, ProofRequirement.OPTIONAL, ProofRequirement.REQUIRED];
	return editUnit === DurationUnit.Minutes ? baseOptions : [...baseOptions, ProofRequirement.REQUIRED_AFTER_DAYS];
}
